import { SVGProps } from "react";

export const PersonTypeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 10.5 14.0004"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 14.0004H9.33333V11.0586C9.33287 10.6013 9.15099 10.1628 8.8276 9.83945C8.50422 9.51607 8.06575 9.33419 7.60842 9.33372H2.89158C2.43425 9.33419 1.99578 9.51607 1.67239 9.83945C1.34901 10.1628 1.16713 10.6013 1.16667 11.0586V14.0004H0V11.0586C0.000926233 10.292 0.305872 9.55708 0.847948 9.01501C1.39002 8.47293 2.12497 8.16798 2.89158 8.16706H7.60842C8.37503 8.16798 9.10998 8.47293 9.65205 9.01501C10.1941 9.55708 10.4991 10.292 10.5 11.0586V14.0004Z"
      fill="#706A85"
    />
    <path
      d="M5.24997 7C4.55773 7 3.88104 6.79473 3.30547 6.41015C2.7299 6.02556 2.28129 5.47894 2.01639 4.83939C1.75148 4.19985 1.68217 3.49612 1.81722 2.81719C1.95227 2.13825 2.28561 1.51461 2.77509 1.02513C3.26458 0.535644 3.88822 0.202301 4.56715 0.0672531C5.24608 -0.0677952 5.94982 0.0015165 6.58936 0.266423C7.2289 0.53133 7.77552 0.979934 8.16011 1.55551C8.54469 2.13108 8.74997 2.80777 8.74997 3.5C8.74904 4.42798 8.37999 5.31768 7.72382 5.97385C7.06764 6.63003 6.17794 6.99908 5.24997 7V7ZM5.24997 1.16667C4.78848 1.16667 4.33735 1.30352 3.95364 1.55991C3.56992 1.8163 3.27085 2.18071 3.09425 2.60707C2.91764 3.03343 2.87143 3.50259 2.96147 3.95521C3.0515 4.40784 3.27373 4.8236 3.60005 5.14992C3.92637 5.47624 4.34213 5.69847 4.79476 5.7885C5.24738 5.87853 5.71653 5.83233 6.14289 5.65572C6.56926 5.47912 6.93367 5.18005 7.19006 4.79633C7.44645 4.41262 7.5833 3.96149 7.5833 3.5C7.5833 2.88116 7.33747 2.28767 6.89988 1.85009C6.4623 1.4125 5.8688 1.16667 5.24997 1.16667Z"
      fill="#706A85"
    />
  </svg>
);
